import i18n from 'i18next';
import Backend, { ChainedBackendOptions } from 'i18next-chained-backend';
import LocalStorageBackend, { LocalStorageBackendOptions } from 'i18next-localstorage-backend';
import HttpBackend, { HttpBackendOptions } from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

// REACT_APP_VERSION is being injected by an Azure Pipeline.
// Adding this unqiue number avoids caching problems
// when users don't refetch the translations file after a new app version had been deployed.
const translationVersion = process.env.REACT_APP_VERSION ?? process.env.NODE_ENV;

// Bug #8150: Using localStorage cache fixes a short flash of tranlsation keys on page reload.
// This cache is disabled for local dev server in case a developer edits translation file.
const enableLocalStorageCache = process.env.NODE_ENV !== 'development';

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init<ChainedBackendOptions>({
    returnNull: false,
    fallbackLng: 'en',
    debug: false,
    backend: {
      backends: [LocalStorageBackend, HttpBackend],
      backendOptions: [
        <LocalStorageBackendOptions>{
          prefix: 'epdi_lang_',
          defaultVersion: translationVersion,
          expirationTime: enableLocalStorageCache ? 7 * 24 * 60 * 60 * 1000 : 0,
        },
        <HttpBackendOptions>{
          loadPath: '/locales/{{lng}}/translation.json?v=' + translationVersion,
        },
      ],
    },
    detection: {
      order: ['cookie', 'querystring', 'localStorage', 'path', 'subdomain'],
    },
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;
